import type { ReviewEntryLineItemDefaultValues } from '../types/reviewEntryLineItemDefaultValues'

export const getDefaultReviewEntryLineItem = (): ReviewEntryLineItemDefaultValues => ({
  accountId: '',
  accountName: undefined,
  accountNumber: '',
  amountExclVat: undefined,
  amountInclVat: undefined,
  description: '',
  side: 'debit',
  taxRate: undefined,
  vatAmount: undefined,
  vatAccountNumber: null,
  vatRateId: '',
})
